export default function OperatorIntro({ companyName, onContinue }) {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="max-w-2xl text-center">
        <img src="https://static.wixstatic.com/media/cf458d_f7329a8f179a4571a1951c4ed9431604~mv2.png" alt="NEG" className="h-10 mx-auto mb-8 opacity-60" />
        <h1 className="font-display text-3xl sm:text-4xl text-white mb-3">Welcome to the<br /><span className="text-brand-gold">Beverage Collective</span></h1>
        <p className="text-neutral-400 text-sm mb-8 max-w-lg mx-auto leading-relaxed">
          Your beverage program support platform — powered by Next Experience Group.
        </p>

        <div className="card p-6 text-left mb-6">
          <h2 className="text-sm font-semibold text-brand-gold mb-4">What the Beverage Collective Delivers:</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {[
              { icon: '📈', title: 'Category Support Tiers', desc: 'Your beverage program is scored across Liquor, Beer, Wine, and Non-Alcoholic. Each category receives dedicated support based on its tier.' },
              { icon: '🎓', title: 'Education & Training', desc: 'Access masterclasses, certification programs, bartender training, and sommelier workshops tailored to your program.' },
              { icon: '🎯', title: 'Activations & Programming', desc: 'Seasonal features, tasting events, pairing dinners, and branded experiences — planned and coordinated by NEG.' },
              { icon: '📋', title: 'Compliance & Reporting', desc: 'Submit menus, P-mix reports, and activation proof. Track your compliance status and program participation.' },
              { icon: '🎨', title: 'Creative & Content', desc: 'Menu design, photography, social media content, POS materials, and brand storytelling — all part of your support package.' },
              { icon: '📊', title: 'Analytics & Strategy', desc: 'Category reviews, beverage program consultation, performance reporting, and menu engineering — data-driven insights for your program.' },
            ].map((item, i) => (
              <div key={i} className="flex gap-3">
                <span className="text-xl flex-shrink-0 mt-0.5">{item.icon}</span>
                <div>
                  <p className="text-xs font-semibold text-white mb-1">{item.title}</p>
                  <p className="text-[10px] text-neutral-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card p-5 text-left mb-8">
          <h2 className="text-sm font-semibold text-white mb-3">Your 5-Tier Support System</h2>
          <div className="space-y-2">
            {[
              { tier: 'T1', name: 'Baseline', color: '#999', desc: 'Basic participation with education access and light support.' },
              { tier: 'T2', name: 'Developing', color: '#60a5fa', desc: 'Moderate support with reporting and limited activation eligibility.' },
              { tier: 'T3', name: 'Growth', color: '#34d399', desc: 'Recurring education, seasonal activations, and structured reporting.' },
              { tier: 'T4', name: 'Signature', color: '#fb923c', desc: 'Strategic planning, recurring activations, and enhanced reporting.' },
              { tier: 'T5', name: 'Flagship', color: '#C9A668', desc: 'Leadership advisory, complex activations, analytics, and innovation support.' },
            ].map(t => (
              <div key={t.tier} className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: t.color + '15' }}>
                  <span className="text-xs font-black" style={{ color: t.color }}>{t.tier}</span>
                </div>
                <div>
                  <span className="text-xs font-semibold" style={{ color: t.color }}>{t.name}</span>
                  <span className="text-[10px] text-neutral-500 ml-2">{t.desc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button onClick={onContinue} className="btn-primary text-sm px-10 py-4">
          View My Program
        </button>

        <p className="text-neutral-700 text-[9px] mt-6">Next Experience Group — Beverage Collective</p>
      </div>
    </div>
  );
}
